import React from "react";
import { styled } from "@mui/material/styles";
import { TextField, TextFieldProps } from "@mui/material";

export const CustomTextField = styled(
	({ onKeyDown, onWheel, type, inputProps, ...props }: TextFieldProps) => {
		const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
			if (type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
				e.preventDefault();
			}
			if (onKeyDown) {
				onKeyDown(e);
			}
		};

		const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
			if (type === "number") {
				(e.target as HTMLElement).blur();
			}
			if (onWheel) {
				onWheel(e);
			}
		};

		return (
			<TextField
				type={type}
				onKeyDown={handleKeyDown}
				onWheel={handleWheel}
				inputProps={{
					...inputProps,
					onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => {
						if (type === "number" && (e.key === "ArrowUp" || e.key === "ArrowDown")) {
							e.preventDefault();
						}
						if (inputProps && (inputProps as any).onKeyDown) {
							(inputProps as any).onKeyDown(e);
						}
					},
				}}
				{...props}
			/>
		);
	}
)(({ theme }) => ({
	"& input[type=number]": {
		"-moz-appearance": "textfield",
	},
	"& input[type=number]::-webkit-outer-spin-button": {
		"-webkit-appearance": "none",
		margin: 0,
	},
	"& .MuiInputLabel-root": {
		fontSize: "0.8rem",
		marginTop: "-0.4rem",
	},
	"& .MuiInputLabel-shrink": {
		fontSize: "0.85rem",
		fontWeight: 600, // Increase the font size here
		marginTop: "0.1rem",
	},
	"& input[type=number]::-webkit-inner-spin-button": {
		"-webkit-appearance": "none",
		margin: 0,
	},
	"& .MuiOutlinedInput-input": {
		padding: "9px 13px",
		fontSize: "0.8rem",
		color: "rgb(38, 38, 38)",
	},

	"& .MuiOutlinedInput-input::-webkit-input-placeholder": {
		color: "#767e89",
		opacity: "1",
	},
	"& .MuiOutlinedInput-notchedOutline": {
		borderColor: `${
			theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "#dee3e9"
		}`,
		borderRadius: 0,
	},
	"& .MuiOutlinedInput-input.Mui-disabled": {
		backgroundColor: `${
			theme.palette.mode === "dark" ? "rgba(0, 0, 0, 0.12) " : "#f8f9fb "
		}`,
	},
	"& .MuiOutlinedInput-input.Mui-disabled::-webkit-input-placeholder": {
		color: "#767e89",
		opacity: "1",
	},
}));
